import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDataInput, IBasicDetails } from '../../../../interface/interfaces';

interface IInitialState {
    stagingLoading: boolean;
    stagingData: IBasicDetails[];
    stagingError: string;
}

const initialState: IInitialState = {
    stagingLoading: false,
    stagingData: [],
    stagingError: '',
};

const stagingSlice = createSlice({
    name: 'staging',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchStagingDataPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.stagingLoading = true;
            state.stagingData = [];
            state.stagingError = '';
        },

        fetchStagingDataFulfilled: (state: IInitialState, action: PayloadAction<IBasicDetails[]>) => {
            state.stagingLoading = false;
            state.stagingData = action.payload;
            state.stagingError = '';
        },
        fetchStagingDataFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.stagingLoading = false;
            state.stagingData = [];
            state.stagingError = action.payload;
        },
    },
});

export default stagingSlice.reducer;
export const { fetchStagingDataPending, fetchStagingDataFulfilled, fetchStagingDataFailure } = stagingSlice.actions;
